export const translations = {
  es: {
    nav: {
      services: "Servicios",
      projects: "Proyectos",
      about: "Diferenciadores",
      testimonials: "Testimonios",
      contact: "Contacto",
      cta: "Solicita presupuesto",
    },
    hero: {
      kicker: "Estudio de reformas integrales — Valencia",
      title_1: "Reformas",
      title_2: "que se",
      title_3: "habitan.",
      subtitle:
        "Diseñamos y construimos viviendas atemporales. Acompañamos al cliente desde el primer plano hasta la última junta, con un único interlocutor y precio cerrado.",
      cta_primary: "Solicita tu presupuesto",
      cta_secondary: "Ver proyectos",
      stat_1_value: "106",
      stat_1_label: "Reformas entregadas",
      stat_2_value: "7 años",
      stat_2_label: "De experiencia",
      stat_3_value: "100%",
      stat_3_label: "Precio cerrado",
    },
    marquee: [
      "Reformas integrales",
      "Interiorismo",
      "Cocinas a medida",
      "Baños premium",
      "Dirección de obra",
      "Diseño 3D",
    ],
    services: {
      kicker: "Servicios",
      title: "Un único estudio. Toda la obra.",
      subtitle:
        "Integramos diseño, ejecución y gestión bajo un mismo paraguas para que tú solo tengas que preocuparte de vivir tu casa.",
      items: [
        {
          title: "Reforma integral",
          description:
            "Transformamos viviendas completas con un único contrato, un único responsable y un calendario claro.",
        },
        {
          title: "Interiorismo",
          description:
            "Diseño de interiores a medida. Materiales nobles, iluminación técnica y mobiliario seleccionado.",
        },
        {
          title: "Cocinas a medida",
          description:
            "Cocinas pensadas para durar. Carpintería propia, electrodomésticos premium y acabados artesanales.",
        },
        {
          title: "Baños premium",
          description:
            "Azulejo porcelánico de gran formato y grifería de gama alta. Espacios para el descanso diario.",
        },
        {
          title: "Diseño 3D",
          description:
            "Renders fotorrealistas antes de empezar la obra. Decide con la imagen final delante.",
        },
        {
          title: "Dirección de obra",
          description:
            "Coordinamos gremios, plazos y calidad. Una sola persona te atiende durante todo el proceso.",
        },
      ],
    },
    differentiators: {
      kicker: "Por qué AARK",
      title_a: "No reformamos pisos.",
      title_b: "Construimos hogares.",
      description:
        "Trabajamos para una clientela exigente que valora el silencio, la calidad de los materiales y la palabra dada.",
      items: [
        { num: "01", title: "Precio cerrado", text: "Sin sobrecostes. El presupuesto firmado es el que se paga." },
        { num: "02", title: "Plazo garantizado", text: "Penalización por cada día de retraso. La obra entrega cuando decimos." },
        { num: "03", title: "Materiales nobles", text: "Piedra natural, maderas macizas y acabados artesanales seleccionados." },
        { num: "04", title: "Único interlocutor", text: "Un arquitecto te acompaña de inicio a fin. Sin intermediarios." },
      ],
    },
    projects: {
      kicker: "Proyectos seleccionados",
      title: "Espacios pensados al milímetro.",
      cta: "Ver proyecto",
      all: "Todos los proyectos",
      view_gallery: "Ver galería",
      photos: "fotos",
      close: "Cerrar",
      prev: "Anterior",
      next: "Siguiente",
      items: [
        {
          id: "rescanya",
          title: "Reforma integral Rescanya",
          category: "Reforma integral de vivienda",
          location: "Rescanya, Valencia",
          year: "2024",
          description:
            "Transformación total de la distribución de la vivienda: salón ampliado, cocina abierta e isla central, y reubicación de los baños. Renovación completa de la instalación eléctrica y de la fontanería y saneamiento desde cero. Cambio íntegro de ventanas, alisado de paredes y nuevo techo de pladur. Acabados premium con revestimientos en azulejo porcelánico en los baños, carpintería oculta sin tiradores, mueble TV a medida en madera de nogal y vestidores interiores en chapa de madera.",
        },
        {
          id: "olivereta",
          title: "Reforma integral L'Olivereta",
          category: "Reforma integral de vivienda",
          location: "L'Olivereta, Valencia",
          year: "2024",
          description:
            "Reforma integral de vivienda con cocina abierta, isla con encimera de piedra natural, baños revestidos en azulejo porcelánico con grifería en oro cepillado e iluminación arquitectónica. Entrega llave en mano.",
        },
        {
          id: "nou-moles",
          title: "Cocina Nou Moles",
          category: "Reforma integral · Cocina",
          location: "Nou Moles, Valencia",
          year: "2024",
          description:
            "Reforma integral de cocina con isla central, encimera de mármol y carpintería lacada a medida. Iluminación técnica LED y grifería premium.",
        },
        {
          id: "aldaia",
          title: "Casa de pueblo · Aldaia",
          category: "Reforma integral de vivienda",
          location: "Aldaia, Valencia",
          year: "2024",
          description:
            "Reforma integral de casa de pueblo combinando carácter tradicional con líneas contemporáneas. Distribución optimizada, materiales nobles y acabados artesanales.",
        },
        {
          id: "castellon",
          title: "Baño Castellón",
          category: "Reforma de baño premium",
          location: "Castellón",
          year: "2024",
          description:
            "Baño con mampara de cristal, azulejo tipo zellige, mueble suspendido en madera de nogal y lavabo de porcelana.",
        },
      ],
    },
    testimonials: {
      kicker: "Testimonios",
      title: "Lo que dicen nuestros clientes.",
      items: [
        {
          quote:
            "Trabajar con AARK ha sido la primera reforma de mi vida sin estrés. Plazo cumplido, presupuesto cerrado y un acabado impecable.",
          author: "Marta L.",
          role: "Ruzafa, Valencia",
        },
        {
          quote:
            "Lo que más valoro es haber tenido un único interlocutor para todo. Diseño, obra, decisiones. Nada se perdió por el camino.",
          author: "Javier R.",
          role: "El Cabañal, Valencia",
        },
        {
          quote:
            "Nos entregaron la casa exactamente igual al render. Materiales de primera y una sensibilidad arquitectónica preciosa.",
          author: "Laura y Andrés",
          role: "Patacona, Alboraya",
        },
      ],
    },
    contact: {
      kicker: "Empieza tu proyecto",
      title_a: "Cuéntanos",
      title_b: "tu casa.",
      subtitle:
        "Recibirás una propuesta personalizada en menos de 48 horas. Sin compromiso.",
      form: {
        name: "Nombre y apellidos",
        email: "Correo electrónico",
        phone: "Teléfono",
        project_type: "Tipo de proyecto",
        project_options: [
          "Reforma integral",
          "Interiorismo",
          "Cocina a medida",
          "Baño premium",
          "Otro",
        ],
        surface: "Superficie aproximada (m²)",
        budget: "Presupuesto orientativo",
        budget_options: [
          "30.000€ — 60.000€",
          "60.000€ — 100.000€",
          "100.000€ — 200.000€",
          "+200.000€",
        ],
        message: "Cuéntanos algo más (opcional)",
        submit: "Enviar solicitud",
        sending: "Enviando…",
        success: "Solicitud recibida. Te contactaremos en menos de 48h.",
        error: "No se ha podido enviar. Inténtalo de nuevo.",
        select_default: "— Selecciona —",
      },
      info: {
        title: "Estudio Valencia",
        address: "Calle Vicente Tormo Alfonso\nValencia",
        email: "aarkobras@gmail.com",
        phone: "+34 651 834 785",
        hours: "Lun — Vie · 9:00 a 18:00",
      },
    },
    footer: {
      tagline: "Reformas integrales arquitectónicas en Valencia.",
      copyright: "Todos los derechos reservados.",
      legal: "Aviso legal · Política de privacidad",
    },
  },
  en: {
    nav: {
      services: "Services",
      projects: "Projects",
      about: "Why AARK",
      testimonials: "Testimonials",
      contact: "Contact",
      cta: "Request a quote",
    },
    hero: {
      kicker: "Architectural renovation studio — Valencia",
      title_1: "Spaces",
      title_2: "made",
      title_3: "to live.",
      subtitle:
        "We design and build timeless homes. A single point of contact, a fixed price and the obsession with detail of an architecture studio.",
      cta_primary: "Request your quote",
      cta_secondary: "View projects",
      stat_1_value: "106",
      stat_1_label: "Homes delivered",
      stat_2_value: "7 yrs",
      stat_2_label: "Experience",
      stat_3_value: "100%",
      stat_3_label: "Fixed price",
    },
    marquee: [
      "Full renovations",
      "Interior design",
      "Bespoke kitchens",
      "Premium bathrooms",
      "Site management",
      "3D design",
    ],
    services: {
      kicker: "Services",
      title: "One studio. The whole build.",
      subtitle:
        "We bring design, construction and project management under one roof, so you can just enjoy your home.",
      items: [
        {
          title: "Full renovation",
          description:
            "We transform entire homes with a single contract, a single contact and a clear timeline.",
        },
        {
          title: "Interior design",
          description:
            "Bespoke interior design. Noble materials, technical lighting and curated furniture.",
        },
        {
          title: "Bespoke kitchens",
          description:
            "Kitchens built to last. In-house joinery, premium appliances and artisanal finishes.",
        },
        {
          title: "Premium bathrooms",
          description:
            "Large-format porcelain tile and high-end fittings. Spaces for daily ritual.",
        },
        {
          title: "3D design",
          description:
            "Photorealistic renders before we start. Decide with the final image in front of you.",
        },
        {
          title: "Site management",
          description:
            "We coordinate trades, deadlines and quality. One person looking after you the whole way.",
        },
      ],
    },
    differentiators: {
      kicker: "Why AARK",
      title_a: "We don't refurbish flats.",
      title_b: "We build homes.",
      description:
        "We work for a demanding clientele that values silence, the quality of materials and the word given.",
      items: [
        { num: "01", title: "Fixed price", text: "No surprises. The signed quote is what you pay." },
        { num: "02", title: "Guaranteed deadline", text: "Penalty for every day of delay. We deliver when we say." },
        { num: "03", title: "Noble materials", text: "Natural stone, solid woods and curated artisanal finishes." },
        { num: "04", title: "Single point of contact", text: "An architect with you from start to finish. No middlemen." },
      ],
    },
    projects: {
      kicker: "Selected projects",
      title: "Spaces designed down to the millimetre.",
      cta: "View project",
      all: "All projects",
      view_gallery: "View gallery",
      photos: "photos",
      close: "Close",
      prev: "Previous",
      next: "Next",
      items: [
        {
          id: "rescanya",
          title: "Rescanya Full Renovation",
          category: "Full home renovation",
          location: "Rescanya, Valencia",
          year: "2024",
          description:
            "Full transformation of the home layout: expanded living room, open kitchen with central island and relocated bathrooms. Brand-new electrical, plumbing and drainage installations from scratch. Complete window replacement, smoothed walls and new plasterboard ceiling. Premium finishes with porcelain tile cladding in the bathrooms, handle-less concealed joinery, custom walnut TV unit and walnut-veneer dressing rooms.",
        },
        {
          id: "olivereta",
          title: "L'Olivereta Full Renovation",
          category: "Full home renovation",
          location: "L'Olivereta, Valencia",
          year: "2024",
          description:
            "Full home renovation with open kitchen, natural stone island, porcelain-tiled bathrooms with brushed gold fittings and architectural lighting. Turn-key delivery.",
        },
        {
          id: "nou-moles",
          title: "Nou Moles Kitchen",
          category: "Full kitchen renovation",
          location: "Nou Moles, Valencia",
          year: "2024",
          description:
            "Full kitchen renovation with central island, marble countertop and bespoke lacquered joinery. Technical LED lighting and premium fittings.",
        },
        {
          id: "aldaia",
          title: "Townhouse · Aldaia",
          category: "Full home renovation",
          location: "Aldaia, Valencia",
          year: "2024",
          description:
            "Full renovation of a townhouse blending traditional character with contemporary lines. Optimised layout, noble materials and artisanal finishes.",
        },
        {
          id: "castellon",
          title: "Castellón Bathroom",
          category: "Premium bathroom renovation",
          location: "Castellón",
          year: "2024",
          description:
            "Bathroom with glass screen, zellige tiling, wall-hung walnut vanity and porcelain basin.",
        },
      ],
    },
    testimonials: {
      kicker: "Testimonials",
      title: "What our clients say.",
      items: [
        {
          quote:
            "Working with AARK was the first stress-free renovation of my life. On time, on budget and flawless finish.",
          author: "Marta L.",
          role: "Ruzafa, Valencia",
        },
        {
          quote:
            "What I value most is having had a single point of contact for everything. Design, build, decisions — nothing got lost.",
          author: "Javier R.",
          role: "El Cabañal, Valencia",
        },
        {
          quote:
            "They delivered exactly what the renders promised. Top-tier materials and a beautiful architectural sensitivity.",
          author: "Laura & Andrés",
          role: "Patacona, Alboraya",
        },
      ],
    },
    contact: {
      kicker: "Start your project",
      title_a: "Tell us",
      title_b: "your home.",
      subtitle:
        "You'll receive a tailored proposal in under 48 hours. No commitment.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        project_type: "Project type",
        project_options: [
          "Full renovation",
          "Interior design",
          "Bespoke kitchen",
          "Premium bathroom",
          "Other",
        ],
        surface: "Approx. surface (m²)",
        budget: "Indicative budget",
        budget_options: [
          "€30,000 — €60,000",
          "€60,000 — €100,000",
          "€100,000 — €200,000",
          "+€200,000",
        ],
        message: "Tell us more (optional)",
        submit: "Send request",
        sending: "Sending…",
        success: "Request received. We'll be in touch within 48h.",
        error: "Couldn't send. Please try again.",
        select_default: "— Select —",
      },
      info: {
        title: "Valencia Studio",
        address: "Calle Vicente Tormo Alfonso\nValencia",
        email: "aarkobras@gmail.com",
        phone: "+34 651 834 785",
        hours: "Mon — Fri · 9:00 to 18:00",
      },
    },
    footer: {
      tagline: "Architectural full renovations in Valencia.",
      copyright: "All rights reserved.",
      legal: "Legal notice · Privacy policy",
    },
  },
};
